/* eslint import/no-extraneous-dependencies: 0 */
import { t } from '@lingui/macro';

import { Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import { StatusFilter, TimeRangeFilter, SiteGroupFilter, BusinessServiceGroupFilter } from '../../filters';
import MapPanel from '../../panels/map-panel/MapPanel';

export const pageId = 'sites-overview';

export default function SitesOverviewPage() {
    return (
        <Page id={pageId}>
            <PageHeader title={t`Sites Overview`}>
                <FilterContainer>
                    <StatusFilter />
                    <TimeRangeFilter required />
                    <SiteGroupFilter />
                    <BusinessServiceGroupFilter />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <MapPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
